import $ from 'jquery';
import { get } from '../../../home24/core/registry';

export function _getTrackingData() {
  return get('trackingData');
}

export function addressSendTrackingData() {
  var trackingData = _getTrackingData();

  if (
    trackingData &&
    trackingData.length > 0 &&
    typeof window.dataLayer !== 'undefined'
  ) {
    window.dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            step: 2
          }
        },
        products: trackingData
      }
    });
  }
}

export function indexSendTrackingData() {
  var trackingData = _getTrackingData();

  if (
    trackingData &&
    trackingData.length > 0 &&
    typeof window.dataLayer !== 'undefined'
  ) {
    window.dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            step: 4
          },
          products: trackingData
        }
      }
    });
  }
}

export function paymentSendTrackingData() {
  var trackingData = _getTrackingData();

  if (
    trackingData &&
    trackingData.length > 0 &&
    typeof window.dataLayer !== 'undefined'
  ) {
    window.dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            step: 3
          },
          products: trackingData
        }
      }
    });
  }
}

export function successSendTrackingData() {
  var productData = _getTrackingData();
  var currencyCode;
  var i;

  if (
    productData &&
    productData.order &&
    productData.products &&
    typeof window.dataLayer !== 'undefined'
  ) {
    var oClonedData = $.extend(true, {}, productData);

    // cleanup

    for (i in oClonedData.products) {
      /* istanbul ignore else */
      if (oClonedData.products.hasOwnProperty(i)) {
        if (oClonedData.products[i].currencyCode) {
          currencyCode = oClonedData.products[i].currencyCode;
        }

        delete oClonedData.products[i].currencyCode;
      }
    }

    window.dataLayer.push({
      ecommerce: {
        currencyCode: currencyCode,
        purchase: {
          actionField: oClonedData.order,
          products: oClonedData.products
        }
      }
    });
  }
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/tracking/checkout/helper.js
 **/